module.exports = {"normal":"Normal","elite":"Elite","boss":"Boss","finalboss":"Final boss","rare":"Rare"};